import { markRaw } from "vue"
import { Deserializer } from "@/flows/Deserializer"
import {
  actions,
  getFlowGetters,
  getterKeyToFunctionMap,
} from "@/flows/schema/flowDataAccess"
import { IFlowValues } from "@/flows/model/flowValues.types"
import { mapperFunctions } from "@/flows/schema/mappers"
import { parseRawFlow } from "@/flows/model/flow.parser"
import { IFlowRaw } from "@/flows/model/flowRaw"
import IFlowConfig from "@/flows/IFlowConfig"

export const getDeserializedFlow = (
  flowRaw: IFlowRaw,
  flowConfig: IFlowConfig,
  values: IFlowValues,
) => {
  const nonReactiveFlowConfig = markRaw(flowConfig)

  const deserializer = new Deserializer(
    getFlowGetters(nonReactiveFlowConfig, {
      ...values,
    }),
    getterKeyToFunctionMap(nonReactiveFlowConfig, values),
    mapperFunctions,
    actions,
  )

  const flow = parseRawFlow(flowRaw, flowConfig, deserializer)

  return deserializer.aggregator.setData(flow).getAggregate()
}
